import clone from "clone";
const indexPage = {
    data() {
        return {
            searchData: {},
            tableLoading: false,
            indexUrl: '',
            deleteUrl: '',
            tableData: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 1,
                data: []
            },
            routeName: ''
        }
    },
    watch: {
        navList(value) {
            const res = value.some(item => item.name == this.routeName);
            if (!res) {
                this.$destroy();
            }
        }
    },
    computed: {
        navList() {
            return this.$store.state.app.tagNavList;
        }
    },
    methods: {
        getData(page) {
            if (this.indexUrl.length <= 0) {
                return;
            }
            this.tableLoading = true;
            let data = clone(this.searchData);
            data.page =page;
            this.$axios.get(this.indexUrl, data).then(res => {
                this.tableData = res.data;
                var rec=res.data.records
                for(var i in rec){
                    if(rec[i].sourceChargeList){
                        rec[i].children=rec[i].sourceChargeList
                    }
                }
                this.tableData.current_page=page
                this.tableData.records=rec
                this.tableLoading = false;
            });
        },
        reload() {
            let page = Math.ceil(this.tableData.total / 10);
            if (page >= this.tableData.current_page) {
                page = this.tableData.current_page;
            }
            this.getData(page);
        },
        remove(id) {
            if (this.deleteUrl.length <= 0) {
                return;
            }
            this.$axios.post(this.deleteUrl, {
                id: id,
            }).then(res => {
                this.$Modal.remove();
                if (res.code == 1) {
                    this.$Message.info("删除成功");
                    this.tableData.total--;
                    this.getData(this.tableData.current_page);
                } else {
                    this.$Message.error(res.msg);
                }
            });
        },
        exportData() {
            if (this.exportUrl.length <= 0) {
                return;
            }
            let data = clone(this.searchData);
            let url = this.$axios.getUri(this.exportUrl, data);
            window.open(this.path + url, '_blank');
        }
    },
    activated() {
        this.getData(this.tableData.current_page);
        this.routeName = this.$route.name;
    }
}
export default indexPage